
export const APP_VERSION = "V103.0";
export const LAST_UPDATE = new Date().toISOString();
